import { replace, toUpper } from 'ramda';

export default replace(/\b\w/g, toUpper);
